<template>
  <v-data-table
    :headers="headers"
    :items="content"
    item-key="doc_id"
    hide-actions
  >
    <template slot="items" slot-scope="props">
      <tr
        :class="{'red--text': props.item.dc == 0, 'green--text': props.item.dc == 1}"
      >
        <td class="text-xs-right">{{ props.item.doc_id }}</td>
        <td>{{ props.item.title }}</td>
        <td>{{ props.item.created_on }}</td>
        <td class="text-xs-right">
          {{ props.item.summa }}
          <span class="grey--text currency">{{currencies[props.item.valuti_id]}}</span>
        </td>
        <td class="text-xs-right">{{ props.item.kurs }}</td>
        <td class="text-xs-right">{{ props.item.itog }}</td>
        <td class="text-xs-right">{{ props.item.balance | numberFormat(2, '.', ' ') }}</td>
        <td class="text-xs-left">
          <v-tooltip bottom v-if="openableDocuments.indexOf(props.item.name) !== -1">
            <v-icon
              class="mr-2"
              slot="activator"
              @click="openDocument(props.item)"
            >
              mdi-file-find
            </v-icon>
            <span>Открыть</span>
          </v-tooltip>
        </td>
      </tr>
    </template>
    <template slot="no-data">
      <empty-table
        :emptyText="'За выбранный период документы отсутствуют'"
      />
    </template>
  </v-data-table>
</template>

<script>
import balanceDisplay from '../mixins/balanceDisplay'

export default {
  name: 'BalanceTable',
  mixins: [
    balanceDisplay
  ],
  data () {
    return {
      headers: [
        {
          text: '№',
          align: 'right',
          width: '100px',
          sortable: false,
          value: 'doc_id'
        },
        {
          text: 'Документ',
          align: 'left',
          sortable: false,
          value: 'title'
        },
        {
          text: 'Дата',
          width: '200px',
          sortable: false,
          value: 'created_on'
        },
        {
          text: 'Сумма',
          width: '120px',
          align: 'right',
          sortable: false,
          value: 'summa'
        },
        {
          text: 'Ед.Изм.',
          sortable: false,
          align: 'right',
          width: '120px',
          value: 'kurs'
        },
        {
          text: 'Итого',
          width: '120px',
          sortable: false,
          align: 'right',
          value: 'itog'
        },
        {
          text: 'Движение',
          width: '120px',
          sortable: false,
          align: 'right',
          value: 'balance'
        },
        {
          text: '',
          align: 'center',
          width: '70px',
          value: 'actions',
          sortable: false
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
